import { StyleObj } from '../types';

export type BorderMixin = (color: string, width?: number) => StyleObj;

export const borderMixin: BorderMixin = (color, width = 1) => {
  return {
    borderColor: color,
    borderStyle: 'solid',
    borderWidth: width,
  };
};
